import { create } from 'zustand'

const adminSetting = (set: any) => ({
  changePasswordModal: false,
  setChangePasswordModal: (state: boolean) =>
    set(() => ({
      changePasswordModal: state,
    })),
  addAdminModal: false,
  setAddAdminModal: (state: boolean) =>
    set(() => ({
      addAdminModal: state,
    })),
  mailNotFoundModal: false,
  setMailNotFoundModal: (state: boolean) =>
    set(() => ({ mailNotFoundModal: state })),
  mailFoundModal: false,
  setMailFoundModal: (state: boolean) => set(() => ({ mailFoundModal: state })),

  // data
  adminData: null,
  setAdminData: (state: any) => set(() => ({ adminData: state })),
  newEmail: null,
  setNewEmail: (state: string) => set(() => ({ newEmail: state })),
})
export const adminSettingStore = create(adminSetting)
